import { defineSlotRecipe } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: menuAnatomy.keys(),
  base: {
    trigger: {
      '& > span': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    content: {
      boxShadow: 'lg',
    },
  },
});
